import LBox from "@components/LBox";
import { AccessCarouselData } from "./types";
import { Platform } from "react-native";
import LText from "@components/LText";
import LArtwork from "@components/LArtwork";

const AccessTypeMusic = ({ data }: { data: AccessCarouselData }) => {
  return (
    <LBox flex={1} mt="s3" px="s3">
      <LBox flexDirection="row" gap="s3" alignItems="center">
        <LBox borderRadius="s-s" overflow="hidden" height={45} width={45}>
          <LArtwork size={45} url={data.songImage} />
          {data.canPreview && (
            <LBox
              position="absolute"
              bottom={0}
              left={0}
              right={0}
              backgroundColor="white"
            >
              <LText
                fontSize={8}
                lineHeight={12}
                color="black"
                textAlign="center"
              >
                Preview
              </LText>
            </LBox>
          )}
        </LBox>
        <LBox flex={1} gap="s1">
          <LText
            fontSize={14}
            lineHeight={16}
            color="white"
            fontFamily="Inter-SemiBold"
            style={
              Platform.OS === "web"
                ? ({ overflowX: "clip", overflowY: "visible" } as any)
                : undefined
            }
            mt={Platform.OS === "web" ? "zero" : "s1_5"}
            numberOfLines={1}
          >
            {data.title}
          </LText>
          {data.subtitle && (
            <LText
              fontSize={10}
              lineHeight={14}
              color="whiteTranslucent80"
              fontWeight="500"
            >
              {data.subtitle}
            </LText>
          )}
        </LBox>
        {!data.unlocked && (
          <LBox
            backgroundColor="whiteTranslucent20"
            py="s1"
            px="s2"
            borderRadius="max"
            alignItems="center"
          >
            <LText fontSize={12} lineHeight={16} color="white" fontWeight="500">
              Unlock
            </LText>
          </LBox>
        )}
      </LBox>
    </LBox>
  );
};

export default AccessTypeMusic;
